{
  "checkout": {
    "title": "Checkout",
    "cart_summary": "{{count}} item in cart",
    "cart_summary_plural": "{{count}} items in cart",

    "tva": "VAT (18%)",
    "delivery_fee": "Delivery fee",
    "service_fee": "Service fee",
    "total": "Total",
    "cart_item": "{{count}} item in cart",
    "cart_item_plural": "{{count}} items in cart",

    "steps": {
      "info": "Information",
      "payment": "Payment",
      "confirmation": "Confirmation",
      "aria_label": "Order steps"
    },

    "info": {
      "title": "Your information",
      "subtitle": "Enter your details for delivery. No account needed.",
      "full_name_label": "Full name",
      "full_name_placeholder": "Abdou Diallo",
      "phone_label": "Phone *",
      "email_label": "Email (optional)",
      "address_label": "Full address *",
      "address_placeholder": "Number, street, house / apartment",
      "quartier_label": "Neighborhood *",
      "quartier_placeholder": "e.g. Hann Mariste",
      "commune_label": "Commune *",
      "commune_placeholder": "e.g. Hann Bel-Air",
      "region_label": "Region *",
      "region_placeholder": "Select your region",
      "privacy_prefix": "I accept the",
      "privacy_link": "privacy policy",
      "privacy_suffix": "of Djayma",
      "continue": "Continue"
    },

    "validation": {
      "name_required": "Full name must be at least 2 characters",
      "phone_invalid": "Phone number must be in Senegalese format (+221 XX XXX XX XX).",
      "email_invalid": "Email address is not valid.",
      "address_required": "Address is required",
      "quartier_required": "Neighborhood is required",
      "commune_required": "Commune is required",
      "region_required": "Please select a region",
      "privacy_required": "You must accept the privacy policy to continue.",
      "required": "This field is required"
    },

    "payment": {
      "title": "Payment method",
      "subtitle": "Choose how you would like to pay for your order.",
      "wave": "Wave",
      "wave_description": "Mobile payment via Wave",
      "orange_money": "Orange Money",
      "orange_money_description": "Mobile payment via Orange Money",
      "cash": "Cash on delivery",
      "cash_description": "Pay in cash when your order is delivered",
      "phone_label": "{{provider}} number *",
      "instructions": "You will receive a payment request on this number.",
      "total_label": "Total to pay",
      "back": "Back",
      "confirm": "Confirm payment",
      "cod_ineligible": {
        "max_amount": "Cash on delivery is not available for orders above {{amount}}.",
        "min_amount": "Cash on delivery is available from {{amount}}.",
        "zone_restricted": "Cash on delivery is not available in your delivery zone.",
        "max_pending": "You have reached the maximum number of pending cash-on-delivery orders.",
        "cod_disabled": "Cash on delivery is temporarily unavailable.",
        "default": "Cash on delivery is not available for this order."
      }
    },

    "confirm_modal": {
      "title": "Confirm payment",
      "subtitle": "Review the details before confirming",
      "amount_label": "Amount to pay",
      "method_label": "Payment method",
      "phone_label": "Phone number",
      "cod_notice": "Payment is made in cash upon delivery.",
      "mobile_money_notice": "You will receive a {{provider}} payment request on your phone. Approve it to confirm your order.",
      "cancel": "Cancel",
      "pay_now": "Pay {{amount}}",
      "processing": "Processing..."
    },

    "polling": {
      "waiting": "Waiting for {{provider}} confirmation...",
      "waiting_description": "Please confirm the payment on your phone. This page updates automatically.",
      "confirmed": "Payment confirmed!",
      "confirmed_description": "Your payment via {{provider}} was received successfully.",
      "timeout": "Payment not received",
      "timeout_description": "We did not receive confirmation of your {{provider}} payment within the allowed time.",
      "failed": "Payment failed",
      "failed_message": "The payment failed. Please try again.",
      "failed_generic": "The payment via {{provider}} failed.",
      "retry": "Try again"
    },

    "confirmation": {
      "success": "Order confirmed!",
      "reference": "Your order reference:",
      "summary": "Order summary",
      "subtotal_ht": "Subtotal (excl. VAT)",
      "tva": "VAT (18%)",
      "delivery": "Delivery fee",
      "total_ttc": "Total incl. VAT",
      "delivery_address": "Delivery address",
      "payment": "Payment",
      "whatsapp_confirm": "Confirm order via WhatsApp",
      "track_order": "Track my order",
      "back_home": "Back to home"
    },

    "post_checkout": {
      "title": "Want to get more benefits?",
      "create_account_prompt": "Create an account to get discounts on your next orders! Also access your order history and saved delivery addresses.",
      "create_account_button": "Create my account",
      "dismiss": "No thanks, maybe later"
    },

    "errors": {
      "price_changed": "Prices have changed. Please refresh your cart.",
      "network": "Network error. Please check your connection.",
      "order_failed": "An error occurred while creating your order. Please try again."
    },

    "delivery": {
      "title": "Your delivery address",
      "error_loading_zones": "Unable to load delivery zones. Please try again.",
      "retry": "Try again",
      "no_zones": "No delivery zones are currently available.",
      "contact_us": "Contact us at {{phone}} to place your order.",
      "back_to_cart": "Back to cart",
      "continue_to_payment": "Continue to payment",
      "errors": {
        "name_required": "Full name is required",
        "name_too_short": "Name must be at least 3 characters",
        "phone_required": "Phone number is required",
        "phone_invalid": "Invalid Senegalese number (e.g. 77 123 45 67)",
        "address_required": "Address is required",
        "address_too_short": "Address must be at least 10 characters",
        "commune_required": "Delivery zone is required",
        "zone_required": "Select a delivery zone",
        "method_unavailable": "No delivery method available for this zone",
        "privacy_required": "You must accept the privacy policy"
      },
      "validation_summary": {
        "title": "Fix these errors to continue"
      },
      "address_form": {
        "title": "Delivery address",
        "full_name": "Full name",
        "full_name_placeholder": "Abdou Diallo",
        "phone": "Phone",
        "phone_placeholder": "77 123 45 67",
        "address": "Full address",
        "address_placeholder": "Number, street, building / apartment",
        "commune": "Delivery zone",
        "commune_placeholder": "Search your zone...",
        "email": "Email (optional)",
        "email_placeholder": "your@email.com",
        "gps_button": "Locate me automatically",
        "gps_denied": "Select your neighbourhood from the list above",
        "privacy_prefix": "I accept the",
        "privacy_link": "privacy policy",
        "privacy_suffix": "of Djayma"
      },
      "method": {
        "title": "Delivery method",
        "standard": "Standard delivery",
        "express": "Express delivery"
      },
      "map": {
        "unavailable": "Map unavailable",
        "load_error": "Failed to load the map",
        "your_position": "Your position",
        "drag_instruction": "Drag the pin to refine your exact position"
      },
      "summary": {
        "items_count": "{{count}} item",
        "items_count_plural": "{{count}} items",
        "subtotal_label": "Total:",
        "subtotal_ht": "Subtotal (excl. VAT)",
        "tva": "VAT (18%)",
        "delivery_fee": "Delivery fee",
        "service_fee": "Service fee",
        "free": "Free",
        "free_delivery_threshold": "Free delivery from {{amount}}",
        "total_ttc": "Total incl. VAT"
      }
    },

    "whatsapp": {
      "confirm_cta": "Confirm via WhatsApp",
      "payment_instruction": "Send exactly",
      "payment_to": "to the CIEDA {{provider}} number",
      "copy_number": "Copy number",
      "copied": "Copied!",
      "merchant_number_unavailable": "The CIEDA payment number isn't set up yet. Call us at +221 76 604 22 74 to finalize your order.",
      "next_steps_title": "Next steps",
      "step_pay": "Send payment via {{provider}}",
      "step_confirm": "We confirm your order within 2h",
      "step_deliver": "Delivery to your zone",
      "reopen_whatsapp": "Open WhatsApp again",
      "order_received": "Order received!"
    }
  },

  "tracking": {
    "title": "Order tracking",
    "subtitle": "Enter your order reference to track your delivery.",
    "reference_placeholder": "E.g. CMD-20260215-0042",
    "search": "Search",
    "reference_label": "Order reference",
    "ordered_on": "Ordered on",
    "not_found": "Order not found. Please check the reference and try again.",
    "estimated_delivery": "Estimated delivery:",
    "summary": "Order summary",
    "subtotal": "Subtotal",
    "tax": "VAT (18%)",
    "total": "Total incl. VAT",
    "status_pending": "Pending",
    "status_confirmed": "Confirmed",
    "status_processing": "Processing",
    "status_shipped": "Shipped",
    "status_delivered": "Delivered"
  }
}
